import { differenceInCalendarDays, startOfMonth, subMonths } from 'date-fns';

export interface DefaultDateRange {
  dateFrom: Date;
  dateTo: Date;
}

const DEFAULT_MIN_DAYS = 60;
const DEFAULT_MONTHS_BACK = 2;

export function getDefaultDateRange(
  today: Date,
  minDays = DEFAULT_MIN_DAYS
): DefaultDateRange {
  let monthsBack = DEFAULT_MONTHS_BACK;
  let dateFrom = startOfMonth(subMonths(today, monthsBack));

  while (differenceInCalendarDays(today, dateFrom) < minDays) {
    monthsBack += 1;
    dateFrom = startOfMonth(subMonths(today, monthsBack));
  }

  return { dateFrom, dateTo: today };
}
